import Page from "../Common/Page";
import React, { ReactNode } from "react";
import {
  Table,
  Form,
  Button,
  Row,
  Col,
  Select,
  Space,
  InputNumber,
  Tooltip,
  Tag,
  message,
  Modal,
} from "antd";
import { JudgmentUnitSelecter } from "../Components/JudgmentUnitSelecter";
import { CommonMasterSelect } from "../Components/CommonMasterSelect";
import { http } from "../Common/http";
import { AuthContext } from "../Auth/Auth";
import {
  CheckOutlined,
  ExclamationCircleOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  FieldTimeOutlined,
  FolderOpenOutlined,
  FolderOutlined,
  WarningTwoTone,
} from "@ant-design/icons";
import { formatTimeSpan, getSubjectOptions } from "../Common/Utils";
import withRouterDom from "../Common/WithReactRouterDom";
import moment from "moment";
import { AuthorityButton } from "../Components/AuthorityButton";
import { AbsenceTag } from "../Common/Icons";
import { Messages } from "../Common/ValidateMessages";

const { Option } = Select;
const { confirm } = Modal;

class ScoringResultListPage extends React.Component<any, any> {
  static contextType = AuthContext;
  private _page: React.RefObject<Page>;
  private _pageSize = 100;

  constructor(props: any, context) {
    super(props, context);
    this._page = React.createRef<Page>();

    const { location } = this.props;
    this.state = {
      defaultFy: location.state?.fy
        ? location.state?.fy
        : context.user.currentYear.toString(),
      judgementUnitId: location.state?.judgementUnitId
        ? location.state?.judgementUnitId
        : "",
      examinationSubjectId: location.state?.examinationSubjectId
        ? location.state?.examinationSubjectId
        : "",
      status: location.state?.status ? location.state?.status : null,
      page: location.state?.page ? location.state?.page : 1,

      subjectOptions: [],
      datas: [],
      applicantCount: [0, 0, 0, 0],
      examinationSubject: undefined,
      selectedRowKeys: [],
      showGrader: false,
      returnLoading: location.state?.examinationSubjectId ? "1" : "0",
    };
  }
  // async componentDidMount() {
  //   const { location } = this.props;
  //   if (location.state) {
  //     this.setState(
  //       {
  //         examinationSubjectId: location.state?.examinationSubjectId
  //           ? location.state?.examinationSubjectId
  //           : "",
  //       },
  //       async () => await this.onFinish({ page: location.state.page })
  //     );
  //   }
  // }

  onShowGraderClick = (e) => {
    this.setState({
      showGrader: !this.state.showGrader,
    });
  };

  onShowDetail = (e, id) => {
    document.getElementById(`dl_${id}`)!.style.display = "";
    document.getElementById(`op_${id}`)!.style.display = "none";
    document.getElementById(`cl_${id}`)!.style.display = "";
  };

  onHideDetail = (e, id) => {
    document.getElementById(`dl_${id}`)!.style.display = "none";
    document.getElementById(`op_${id}`)!.style.display = "";
    document.getElementById(`cl_${id}`)!.style.display = "none";
  };

  getScoringStatusTag = (scoreItem?: any, objectId?: any): any => {
    if (
      scoreItem.scoringStatus === undefined ||
      scoreItem.scoringStatus === "0"
    ) {
      return (
        <Tag color="gold" className="scoring-status-tag">
          未採点
        </Tag>
      );
    } else if (scoreItem.scoringStatus === "1") {
      return (
        <Tag color="orange" className="scoring-status-tag">
          採点中
        </Tag>
      );
    } else if (scoreItem.scoringStatus === "2") {
      return (
        <Tag
          color="volcano"
          className="scoring-status-tag"
          closable
          closeIcon={<CheckOutlined />}
          onClose={(closeEvent) => {
            closeEvent.preventDefault();
            confirm({
              title: Messages["CON-019"],
              icon: <ExclamationCircleOutlined />,
              onOk: () => {
                this.onChangeToSubmit(objectId, scoreItem.userId);
              },
              onCancel: () => {},
              okText: "はい",
              cancelText: "いいえ",
            });
          }}
        >
          採点完了
        </Tag>
      );
    } else if (scoreItem.scoringStatus === "3") {
      return (
        <Tag
          color="red"
          className="scoring-status-tag"
          closable
          onClose={(closeEvent) => {
            closeEvent.preventDefault();
            confirm({
              title: Messages["CON-020"],
              icon: <ExclamationCircleOutlined />,
              onOk: () => {
                this.onSubmitRemove(objectId, scoreItem.userId);
              },
              onCancel: () => {},
              okText: "はい",
              cancelText: "いいえ",
            });
          }}
        >
          提出済
        </Tag>
      );
    } else if (scoreItem.scoringStatus === "4") {
      return (
        <Tag color="magenta" className="scoring-status-tag">
          確定
        </Tag>
      );
    }
    return "";
  };

  createAllocationColumn = (colIndex: number): any => {
    return {
      title: <div className="table-title">採点者{colIndex + 1}</div>,
      key: `score${colIndex + 1}`,
      width: "10%",
      render: (value: any, item: any, index: number) => {
        if (
          item.scoringResultUserList !== undefined &&
          item.scoringResultUserList.length > colIndex
        ) {
          const score =
            item.scoringResultUserList[colIndex].absenceFlag === "1"
              ? AbsenceTag
              : item.scoringResultUserList[colIndex].score;
          return (
            <Space
              size={2}
              direction="vertical"
              style={{ width: "100%", textAlign: "right" }}
            >
              <span style={{ fontSize: "15px" }}>
                {item.overThreshold === "1" ? (
                  <Tooltip title={Messages["MSG-009"]}>
                    <WarningTwoTone twoToneColor="#dd3333" />
                  </Tooltip>
                ) : (
                  ""
                )}
                {score}
              </span>

              <Space
                size={2}
                direction="vertical"
                style={{ display: this.state.showGrader ? "" : "none" }}
              >
                {this.state.examinationSubject.scoringType === "2" && (
                  <span>
                    <FieldTimeOutlined />
                    {formatTimeSpan(
                      item.scoringResultUserList[colIndex].interviewElapsedTime
                    )}
                  </span>
                )}
                {item.scoringStatus !== "2" &&
                this.state.examinationSubject.scoringAllocationFlag !== "1" ? (
                  <Tag
                    className="scoring-status-tag"
                    closable
                    onClose={(closeEvent) => {
                      closeEvent.preventDefault();
                      confirm({
                        title: Messages["CON-021"],
                        icon: <ExclamationCircleOutlined />,
                        onOk: () => {
                          this.onAllocationRemove(
                            item.groupNo
                              ? item.groupNo.toString()
                              : item.applicantId,
                            item.scoringResultUserList[colIndex].userId
                          );
                        },
                        onCancel: () => {},
                        okText: "はい",
                        cancelText: "いいえ",
                      });
                    }}
                  >
                    {item.scoringResultUserList[colIndex].sei}{" "}
                    {item.scoringResultUserList[colIndex].mei}
                  </Tag>
                ) : (
                  <Tag className="scoring-status-tag">
                    {item.scoringResultUserList[colIndex].sei}{" "}
                    {item.scoringResultUserList[colIndex].mei}
                  </Tag>
                )}

                {item.scoringStatus === "2" ? (
                  <Tag color="magenta" className="scoring-status-tag">
                    確定
                  </Tag>
                ) : (
                  this.getScoringStatusTag(
                    item.scoringResultUserList[colIndex],
                    item.groupNo ? item.groupNo.toString() : item.applicantId
                  )
                )}
              </Space>
            </Space>
          );
        }
      },
      shouldCellUpdate: (record, prevRecord) => {
        return true;
      },
    };
  };

  allocationColumnsInitB = {
    title: <div className="table-title">確定値</div>,
    width: "10%",
    key: "score",
    render: (value: any, item: any, index: number) => {
      if (item.scoringStatus === "2") {
        return (
          <div style={{ width: "100%", textAlign: "right", fontSize: "20px" }}>
            {item.finalScore}
          </div>
        );
      } else if (item.scoringStatus === "1") {
        return (
          <InputNumber
            style={{ fontSize: "20px" }}
            keyboard={true}
            defaultValue={item.finalScore}
            onChange={(value: any) => {
              this.onChangeFixValue(value, index);
            }}
          />
        );
      }
    },
    shouldCellUpdate: (record, prevRecord) => {
      return true;
    },
  };

  columnsInit = [
    {
      title: <div className="table-title">受験番号</div>,
      width: "10%",
      // dataIndex: "examNo",
      key: "examNo",
      render: (value: any, item: any, index: number) => {
        const { navigation } = this.props;
        if (item.scoringStatus === "1" || item.scoringStatus === "3") {
          return (
            <AuthorityButton
              functioncode="FU-49"
              showtext={true}
              type="link"
              onClick={() => {
                navigation(
                  `/ScoringUpdate/${
                    this.state.examinationSubject.examinationSubjectId
                  }/${item.groupNo ? item.groupNo : item.applicantId}/`,
                  {
                    state: {
                      fy: this.state.defaultFy,
                      judgementUnitId: this.state.judgementUnitId,
                      examinationSubjectId: this.state.examinationSubjectId,
                      status: this.state.status,
                      page: this.state.page,
                    },
                  }
                );
              }}
            >
              {item.examNo}
            </AuthorityButton>
          );
        } else {
          return item.examNo;
        }
      },
    },
    {
      title: <div className="table-title">氏名</div>,
      key: "name",
      width: "10%",
      render: (value: any, item: any, index: number) => {
        return (
          <Space size={0} direction="vertical">
            <span>
              {item.sei} {item.mei}
            </span>
            <dl id={`dl_${item.examNo}`} style={{ display: "none" }}>
              <dt>生年月日</dt>
              <dd>{moment(item.birthday).format("yyyy/MM/DD")}</dd>
              <dt>学校名</dt>
              <dd>{item.highSchoolName}</dd>
            </dl>
            <span
              id={`op_${item.examNo}`}
              className="aiScore"
              onClick={(e) => this.onShowDetail(e, item.examNo)}
            >
              <FolderOutlined />
              詳細を見る
            </span>
            <span
              id={`cl_${item.examNo}`}
              className="aiScore"
              onClick={(e) => this.onHideDetail(e, item.examNo)}
              style={{ display: "none" }}
            >
              <FolderOpenOutlined />
              詳細を閉じる
            </span>
          </Space>
        );
      },
    },
    {
      title: <div className="table-title">グループNo</div>,
      width: "5%",
      dataIndex: "groupNo",
      key: "groupNo",
    },

    {
      title: <div className="table-title">ステータス</div>,
      key: "status",
      width: "10%",
      render: (value: any, item: any, index: number) => {
        if (item.scoringStatus === null || item.scoringStatus === "0") {
          return "確定処理不可";
        } else if (item.scoringStatus === "1" || item.scoringStatus === "3") {
          return "未確定";
        } else if (item.scoringStatus === "2") {
          return "確定";
        }
      },
    },
    {
      title: ({ sortOrder, sortColumn, filters }) => (
        <div className="table-title">
          <Space>
            <span>
              合計点
              {this.state.examinationSubject &&
              this.state.examinationSubject.scoringType === "2"
                ? "/面接時間"
                : ""}
            </span>
            <span
              className="aiScore"
              style={{ display: this.state.showGrader ? "none" : "" }}
              onClick={this.onShowGraderClick}
            >
              <EyeInvisibleOutlined />
              採点者表示
            </span>
            <span
              className="aiScore"
              style={{ display: this.state.showGrader ? "" : "none" }}
              onClick={this.onShowGraderClick}
            >
              <EyeOutlined />
              隠す
            </span>
          </Space>
        </div>
      ),
    },
    {
      title: "",
      key: "action1",
      width: "8%",
      render: (value: any, item: any, index: number) => {
        const { navigation } = this.props;
        if (item.scoringStatus === "1") {
          return (
            <AuthorityButton
              functioncode="FU-47"
              authority="2"
              type="primary"
              onClick={() => {
                navigation(
                  `/ScoringConfirm/${
                    this.state.examinationSubject.examinationSubjectId
                  }/${item.groupNo ? item.groupNo : item.applicantId}/`,
                  {
                    state: {
                      fy: this.state.defaultFy,
                      judgementUnitId: this.state.judgementUnitId,
                      examinationSubjectId: this.state.examinationSubjectId,
                      status: this.state.status,
                      page: this.state.page,
                    },
                  }
                );
              }}
            >
              確定値入力
            </AuthorityButton>
          );
        }
      },
    },
    {
      title: (
        <Space direction="vertical">
          <AuthorityButton
            functioncode="FU-47"
            authority="2"
            type="primary"
            onClick={() => {
              confirm({
                title: Messages["CON-034"],
                icon: <ExclamationCircleOutlined />,
                onOk: () => {
                  this.onCommitAll();
                },
                onCancel: () => {},
                okText: "はい",
                cancelText: "いいえ",
              });
            }}
          >
            採点結果を一括提出
          </AuthorityButton>
          <AuthorityButton
            functioncode="FU-47"
            authority="2"
            type="primary"
            onClick={() => {
              confirm({
                title: Messages["CON-022"],
                icon: <ExclamationCircleOutlined />,
                onOk: () => {
                  this.onFixAll();
                },
                onCancel: () => {},
                okText: "はい",
                cancelText: "いいえ",
              });
            }}
          >
            選択項目を一括確定
          </AuthorityButton>
        </Space>
      ),
      key: "action2",
      width: "10%",
      render: (value: any, item: any, index: number) => {
        if (item.scoringStatus === "1") {
          return (
            <AuthorityButton
              functioncode="FU-47"
              authority="2"
              type="primary"
              onClick={() => {
                confirm({
                  title: Messages["CON-023"],
                  icon: <ExclamationCircleOutlined />,
                  onOk: () => {
                    this.onFix(index);
                  },
                  onCancel: () => {},
                  okText: "はい",
                  cancelText: "いいえ",
                });
              }}
            >
              確定
            </AuthorityButton>
          );
        } else if (item.scoringStatus === "2") {
          return (
            <AuthorityButton
              functioncode="FU-47"
              authority="2"
              type="primary"
              onClick={() => {
                confirm({
                  title: Messages["CON-024"],
                  icon: <ExclamationCircleOutlined />,
                  onOk: () => {
                    this.onFixRemove(index);
                  },
                  onCancel: () => {},
                  okText: "はい",
                  cancelText: "いいえ",
                });
              }}
            >
              確定解除
            </AuthorityButton>
          );
        }
      },
    },
  ];
  columns = this.columnsInit;

  setSearchResult = (result: any) => {
    const scoringNumOfPeople = result.body.examinationSubject.scoringNumOfPeople
      ? result.body.examinationSubject.scoringNumOfPeople
      : 0;
    const groupCreationRequiredFlag = result.body.examinationSubject
      .groupCreationRequiredFlag
      ? result.body.examinationSubject.groupCreationRequiredFlag
      : "0";

    const allocationColumns: any[] = [];
    for (let colIndex = 0; colIndex < scoringNumOfPeople; colIndex++) {
      allocationColumns.push(this.createAllocationColumn(colIndex));
    }
    allocationColumns.push(this.allocationColumnsInitB);
    // this.allocationColumnsInitA
    //   .slice(0, scoringNumOfPeople)
    //   .concat(this.allocationColumnsInitB);
    if (groupCreationRequiredFlag === "0") {
      this.columns = this.columnsInit
        .slice(0, 2)
        .concat(this.columnsInit.slice(3));
      this.columns[3]["children"] = allocationColumns;
    } else {
      this.columns = this.columnsInit;
      this.columns[4]["children"] = allocationColumns;
    }

    this.setState(
      {
        examinationSubject: result.body.examinationSubject,
      },
      () => {
        this.setState({
          selectedRowKeys: [],
          datas: result.body.applicantScoringResultList
            ? [...result.body.applicantScoringResultList]
            : null,
          applicantCount: result.body.applicantCount,
        });
      }
    );

    if (result.body.applicantCount[3] > 0) {
      message.error(Messages["ERR-087"]);
    }
  };
  onFinish = async (values: any) => {
    // console.log("search:", values);
    try {
      this._page.current?.setState({ isPageLoading: true });
      this.setState({
        detailTeacherName: "",
        detailDatas: [],
        page: values.page ? values.page : 1,
      });
      const searchData = {
        fy: this.state.defaultFy,
        examinationSubjectId: this.state.examinationSubjectId,
        status: this.state.status,
      };
      const result = await http<any, any>({
        path: "/ScoreAllocation/searchscoringresult",
        method: "post",
        body: searchData,
        accessToken: this.context.accessToken,
      });
      if (result.ok && result.body) {
        this.setSearchResult(result);
      }
      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      console.log(error);
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  // 採点担当解除
  onAllocationRemove = async (applicantId: string, userId: string) => {
    try {
      this._page.current?.setState({ isPageLoading: true });
      this.setState({
        detailTeacherName: "",
        detailDatas: [],
      });
      const postData = {
        examinationSubjectId:
          this.state.examinationSubject.examinationSubjectId,
        applicantId: applicantId,
        userId: userId,
        status: this.state.searchStatus,
      };
      const result = await http<any, any>({
        path: "/ScoreAllocation/removeallocation",
        method: "post",
        body: postData,
        accessToken: this.context.accessToken,
      });
      this._page.current?.setState({ isPageLoading: false });
      if (result.ok && result.body?.result === "1") {
        this.onFinish({ page: this.state.page });
      } else {
        message.error(Messages["ERR-020"]);
      }
    } catch (error) {
      console.log(error);
      message.error(Messages["ERR-020"]);
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  // 提出撤回
  onSubmitRemove = async (applicantId: string, userId: string) => {
    try {
      this._page.current?.setState({ isPageLoading: true });
      this.setState({
        detailTeacherName: "",
        detailDatas: [],
      });
      const postData = {
        examinationSubjectId:
          this.state.examinationSubject.examinationSubjectId,
        applicantId: applicantId,
        userId: userId,
        status: this.state.searchStatus,
      };
      const result = await http<any, any>({
        path: "/ScoreAllocation/removesubmit",
        method: "post",
        body: postData,
        accessToken: this.context.accessToken,
      });
      this._page.current?.setState({ isPageLoading: false });
      if (result.ok && result.body?.result === "1") {
        this.onFinish({ page: this.state.page });
      } else {
        message.error(Messages["ERR-020"]);
      }
    } catch (error) {
      console.log(error);
      message.error(Messages["ERR-020"]);
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  // 提出
  onChangeToSubmit = async (applicantId: string, userId: string) => {
    try {
      this._page.current?.setState({ isPageLoading: true });
      const postData = {
        examinationSubjectId:
          this.state.examinationSubject.examinationSubjectId,
        applicantId: applicantId,
        userId: userId,
        status: this.state.searchStatus,
      };
      const result = await http<any, any>({
        path: "/ScoreAllocation/changetosubmit",
        method: "post",
        body: postData,
        accessToken: this.context.accessToken,
      });
      this._page.current?.setState({ isPageLoading: false });
      if (result.ok && result.body?.result === "1") {
        this.onFinish({ page: this.state.page });
      } else {
        message.error(Messages["ERR-020"]);
      }
    } catch (error) {
      console.log(error);
      message.error(Messages["ERR-020"]);
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  // 確定解除
  onFixRemove = async (index: number) => {
    const applicantIdSet: any[] = [];
    const applicantScoringResult = this.state.datas[index];
    if (applicantScoringResult.groupNo) {
      this.state.datas.forEach((element) => {
        if (element.groupNo === applicantScoringResult.groupNo) {
          applicantIdSet.push(element.applicantId);
        }
      });
    } else {
      applicantIdSet.push(applicantScoringResult.applicantId);
    }

    try {
      this._page.current?.setState({ isPageLoading: true });
      this.setState({
        detailTeacherName: "",
        detailDatas: [],
      });
      const postData = {
        examinationSubjectId:
          this.state.examinationSubject.examinationSubjectId,
        applicantIdList: applicantIdSet,
        status: this.state.searchStatus,
      };
      const result = await http<any, any>({
        path: "/ScoreAllocation/removefix",
        method: "post",
        body: postData,
        accessToken: this.context.accessToken,
      });
      this._page.current?.setState({ isPageLoading: false });
      if (result.ok && result.body) {
        if (result.body?.result === "0") {
          message.error(Messages["ERR-071"]);
        }
        this.onFinish({ page: this.state.page });
      } else {
        message.error(Messages["ERR-020"]);
      }
    } catch (error) {
      console.log(error);
      message.error(Messages["ERR-020"]);
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  // 確定
  onFix = async (index: number) => {
    const applicantIdSet: any[] = [];
    const finalScoreSet: any[] = [];

    const applicantScoringResult = this.state.datas[index];
    if (applicantScoringResult.groupNo) {
      let haveError = false;
      this.state.datas.forEach((element) => {
        if (element.groupNo === applicantScoringResult.groupNo) {
          if (element.finalScore === null) {
            haveError = true;
            return;
          } else {
            applicantIdSet.push(element.applicantId);
            finalScoreSet.push(element.finalScore);
          }
        }
      });
      if (haveError) {
        message.error(Messages["ERR-072"]);
        return;
      }
    } else {
      if (applicantScoringResult.finalScore === null) {
        message.error(Messages["ERR-073"]);
        return;
      }
      applicantIdSet.push(applicantScoringResult.applicantId);
      finalScoreSet.push(applicantScoringResult.finalScore);
    }

    try {
      this._page.current?.setState({ isPageLoading: true });
      this.setState({
        detailTeacherName: "",
        detailDatas: [],
      });
      const postData = {
        examinationSubjectId:
          this.state.examinationSubject.examinationSubjectId,
        applicantIdList: applicantIdSet,
        finalScoreList: finalScoreSet,
        status: this.state.searchStatus,
      };
      const result = await http<any, any>({
        path: "/ScoreAllocation/fix",
        method: "post",
        body: postData,
        accessToken: this.context.accessToken,
      });
      this._page.current?.setState({ isPageLoading: false });
      if (result.ok && result.body?.result === "1") {
        this._page.current?.setState({ isPageLoading: false });
        this.onFinish({ page: this.state.page });
      }
    } catch (error) {
      console.log(error);
      this._page.current?.setState({ isPageLoading: false });
    }
  };
  // 一括提出
  onCommitAll = async () => {
    if (this.state.datas?.length === 0) {
      message.error(Messages["ERR-093"]);
      return;
    }

    try {
      this._page.current?.setState({ isPageLoading: true });
      this.setState({
        detailTeacherName: "",
        detailDatas: [],
        page: 1,
      });
      const searchData = {
        fy: this.state.defaultFy,
        examinationSubjectId: this.state.examinationSubjectId,
        status: this.state.status,
      };
      const result = await http<any, any>({
        path: "/ScoreAllocation/commitscoringresult",
        method: "post",
        body: searchData,
        accessToken: this.context.accessToken,
      });
      if (result.ok && result.body) {
        message.success(Messages["MSG-018"]);
        this.setSearchResult(result);
      }
      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      console.log(error);
      this._page.current?.setState({ isPageLoading: false });
    }
  };
  // 一括確定
  onFixAll = async () => {
    const applicantIdList = this.state.selectedRowKeys;
    if (applicantIdList.length === 0) {
      message.error(Messages["ERR-074"]);
      return;
    }
    const datas = this.state.datas;
    const finalScoreList: number[] = [];
    const groupList: any[] = [];
    for (let i = 0; i < applicantIdList.length; i++) {
      for (let j = 0; j < datas.length; j++) {
        if (applicantIdList[i] === datas[j].applicantId) {
          if (
            datas[j].groupNo &&
            !groupList.some((g) => g === datas[j].groupNo)
          ) {
            groupList.push(datas[j].groupNo);
          }
          if (datas[j].finalScore === null) {
            message.error(Messages["ERR-073"]);
            return;
          }
          finalScoreList.push(datas[j].finalScore);
          break;
        }
      }
    }
    if (applicantIdList.length !== finalScoreList.length) {
      message.error(Messages["ERR-073"]);
      return;
    }

    for (let j = 0; j < datas.length; j++) {
      if (
        datas[j].groupNo &&
        groupList.some((g) => g === datas[j].groupNo) &&
        !applicantIdList.some((a) => a === datas[j].applicantId)
      ) {
        message.error(Messages["ERR-075"]);
        return;
      }
    }

    try {
      this._page.current?.setState({ isPageLoading: true });
      this.setState({
        detailTeacherName: "",
        detailDatas: [],
      });
      const postData = {
        examinationSubjectId:
          this.state.examinationSubject.examinationSubjectId,
        applicantIdList: applicantIdList,
        finalScoreList: finalScoreList,
        status: this.state.searchStatus,
      };
      const result = await http<any, any>({
        path: "/ScoreAllocation/fix",
        method: "post",
        body: postData,
        accessToken: this.context.accessToken,
      });
      this._page.current?.setState({ isPageLoading: false });
      if (result.ok && result.body?.result === "1") {
        this._page.current?.setState({ isPageLoading: false });
        this.onFinish({ page: this.state.page });
      }
    } catch (error) {
      console.log(error);
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  onChangeFixValue = async (value: any, index: number) => {
    const datas = this.state.datas;
    datas[index].finalScore = value;
    this.setState({
      datas: datas,
    });
  };

  onJudgmentUnitSelected = async (record: any) => {
    // console.log("Success:", record);
    if (
      record &&
      record.fyJudgementUnitId &&
      record.fyJudgementUnitId.length > 0
    ) {
      const subjectOptions = await getSubjectOptions(
        this.context.accessToken,
        record.fyJudgementUnitId,
        undefined,
        undefined,
        undefined
      );
      if (this.state.returnLoading === "1") {
        const { location } = this.props;
        this.setState(
          {
            judgementUnitId: record.fyJudgementUnitId,
            subjectOptions: subjectOptions,
            examinationSubjectId: location.state?.examinationSubjectId
              ? location.state?.examinationSubjectId
              : "",
            returnLoading: "0",
          },
          async () => await this.onFinish({ page: location.state.page })
        );
      } else {
        this.setState(
          {
            judgementUnitId: record.fyJudgementUnitId,
            subjectOptions: subjectOptions,
            examinationSubjectId:
              subjectOptions.length > 0 ? subjectOptions[0].id : "",
            datas: [],
          },
          async () => await this.onFinish({ page: 1 })
        );
      }
    } else {
      this.setState({
        judgementUnitId: "",
        subjectOptions: [],
        examinationSubjectId: "",
        datas: [],
      });
    }
  };

  onDetailLinkClick = (details: [], teacherName: string) => {
    this.setState({
      detailDatas: details,
      detailTeacherName: teacherName,
    });
  };
  onFyChange = (newValue) => {
    this.setState({
      defaultFy: newValue.value,
    });
  };
  onSubjectChanged = (newValue) => {
    this.setState(
      {
        examinationSubjectId: newValue,
        datas: [],
      },
      async () => await this.onFinish({ page: 1 })
    );
  };
  onChangeStatus = (newValue) => {
    this.setState({
      status: newValue,
    });
  };
  onSelectChange = (selectedRowKeys) => {
    // console.log("selectedRowKeys changed: ", selectedRowKeys);
    this.setState({ selectedRowKeys });
  };
  render(): React.ReactNode {
    const { selectedRowKeys } = this.state;
    const rowSelection = {
      selectedRowKeys,
      // columnTitle: "選択",
      fixed: false,
      columnWidth: "5%",
      getCheckboxProps: (record) => ({
        disabled: record.scoringStatus !== "1", // Column configuration not to be checked
        name: record.examNo,
      }),
      onChange: (selectedRowKeys) => {
        // console.log("selectedRowKeys changed: ", selectedRowKeys);
        this.setState({ selectedRowKeys });
      },
    };
    const showTotal = (total: number, range: [number, number]): ReactNode => {
      return (
        <ul className="resultCount">
          <li className="grey">
            未完了<span>{this.state.applicantCount[0]}</span>
          </li>
          <li className="blue">
            完了<span>{this.state.applicantCount[1]}</span>
          </li>
          <li className="red">
            確定<span>{this.state.applicantCount[2]}</span>
          </li>
        </ul>
      );
    };
    return (
      <Page ref={this._page} title="採点結果一覧">
        <div className="data_content">
          <Form
            colon={false}
            className="search_form"
            name="searchForm"
            onFinish={this.onFinish}
            layout={"inline"}
            initialValues={{
              fy: { value: this.state.defaultFy },
              judgementUnitId: this.state.judgementUnitId,
              examinationSubjectId: this.state.examinationSubjectId,
              status: this.state.status,
            }}
            fields={[
              {
                name: "examinationSubjectId",
                value: this.state.examinationSubjectId,
              },
            ]}
          >
            <Row>
              <Col span={6}>
                <Form.Item
                  label="入試年度"
                  name="fy"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <CommonMasterSelect
                    allowClear={false}
                    masterType={31}
                    onChange={this.onFyChange}
                  />
                </Form.Item>
              </Col>
              <Col span={18}>
                <Form.Item
                  label="判定単位"
                  name="judgementUnitId"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <JudgmentUnitSelecter
                    width={500}
                    defaultFy={this.state.defaultFy}
                    onDataSelect={this.onJudgmentUnitSelected}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={6}>
                <Form.Item
                  label="試験科目"
                  name="examinationSubjectId"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Select
                    style={{ width: "160px" }}
                    allowClear={false}
                    onChange={this.onSubjectChanged}
                  >
                    {this.state.subjectOptions.length > 0 &&
                      this.state.subjectOptions.map((data: any) => (
                        <Option key={data.id} value={data.id}>
                          {data.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={10}>
                <Form.Item label="ステータス" name="status">
                  <Select
                    allowClear={true}
                    style={{ width: 160 }}
                    onChange={this.onChangeStatus}
                  >
                    <Option key="0" value="0">
                      確定処理不可
                    </Option>
                    <Option key="1" value="1">
                      未確定
                    </Option>
                    <Option key="2" value="2">
                      確定
                    </Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    表示
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Row>
            <Col span={24}>
              <Table
                rowKey={(record: any) => record.applicantId}
                bordered
                rowSelection={rowSelection}
                showSorterTooltip={false}
                columns={this.columns}
                dataSource={this.state.datas}
                pagination={{
                  position: ["topLeft"],
                  size: "small",
                  // itemRender: (page, type, originalElement) => <></>,
                  showSizeChanger: false,
                  pageSize: this._pageSize,
                  defaultCurrent: this.state.page,
                  showTotal,
                  onChange: (current) => this.setState({ page: current }),
                }}
                rowClassName={(record, index) => {
                  if (record.scoringStatus === "3") {
                    return "background_color_darkred";
                  } else if (record.overThreshold === "1") {
                    return "background_color_red";
                  } else {
                    return "";
                  }
                }}
              />
            </Col>
          </Row>
        </div>
      </Page>
    );
  }
}

export default withRouterDom(ScoringResultListPage);
